import { Inject, Injectable } from '@angular/core';

/**
 * Class contains URL Paths for http requests
 */
@Injectable()
export class UrlService {

  environment;

  constructor(@Inject('env') private envConfig) {
    this.environment = this.envConfig.callback(this.envConfig.value);
  }

  public getCertificateVerification(): string {
    return `${this.environment.certificateServiceUrl}api/public/certificate/getResult`;
  }

  public getTestdafDigitalCertificateVerification(): string {
    return `${this.environment.certificateServiceUrl}api/public/certificate/testdaf-digital/getResult`;
  }

  public getTestdafDigitalFormCertificateVerification(): string {
    return `${this.environment.certificateServiceUrl}api/public/certificate/testdaf-digital/form/result`;
  }

  public getTestdafPaperbasedFormCertificateVerification(): string {
    return `${this.environment.certificateServiceUrl}api/public/certificate/testdaf-paperbased/form/result`;
  }

  public getTestasDigitalFormCertificateVerification(): string {
    return `${this.environment.certificateServiceUrl}api/public/certificate/testas-digital/form/result`;
  }

  public getTestasPaperbasedFormCertificateVerification(): string {
    return `${this.environment.certificateServiceUrl}api/public/certificate/testas-paperbased/form/result`;
  }

  public getTestasDigitalCertificateVerification(): string {
    return `${this.environment.certificateServiceUrl}api/public/certificate/testas-digital/getResult`;
  }

  public getDmatDigitalFormCertificateVerification(): string {
    return `${this.environment.certificateServiceUrl}api/public/certificate/dmat-digital/form/result`;
  }

  public getDmatDigitalCertificateVerification(): string {
    return `${this.environment.certificateServiceUrl}api/public/certificate/dmat-digital/getResult`;
  }

  public getDmatModules(): string {
    return `${this.environment.certificateServiceUrl}api/public/certificate/dmat-digital/modules`;
  }

  public getDtzFormCertificateVerification(): string {
    return `${this.environment.certificateServiceUrl}api/public/certificate/dtz/form/result`;
  }

  public getDtzCertificateVerificationByQrCode(): string {
    return `${this.environment.certificateServiceUrl}api/public/certificate/dtz/result`;
  }

  public getCertificateDataFromPdfUrl(): string {
    return `${this.environment.certificateServiceUrl}api/public/certificate/dtz/data-from-pdf`;
  }

  // auth service
  public getDtzCertificateVerifyUser(): string {
    return `${this.environment.authServiceUrl}api/public/dtz-certificate/verify-user`;
  }

  public getTestdafBestOfCertificateVerificationByQrCode(): string {
    return `${this.environment.certificateServiceUrl}api/public/certificate/best-of-certificate-testdaf/result`;
  }

  public getTestdafBestOfCertificateVerificationForm(): string {
    return `${this.environment.certificateServiceUrl}api/public/certificate/best-of-certificate-testdaf/form`;
  }
}
